(() => {
  const key = 'PawprintCarouselCore';
  window[key]?.cleanup();
  const controller = new AbortController();
  const options = { capture: true, signal: controller.signal };

  function parts(carousel) {
    const view = carousel?.querySelector('.wf-tc-view');
    const track = view?.querySelector('.wf-tc-track');
    const cards = track ? Array.from(track.children).filter(card => card.matches('.wf-tc-card')) : [];
    return view && cards.length ? { view, cards } : null;
  }

  function cardPosition(view, card) {
    const left = view.scrollLeft + card.getBoundingClientRect().left - view.getBoundingClientRect().left - view.clientLeft;
    const centered = getComputedStyle(card).scrollSnapAlign.split(' ').includes('center');
    const target = centered ? left - (view.clientWidth - card.getBoundingClientRect().width) / 2 : left;
    return Math.max(0, Math.min(view.scrollWidth - view.clientWidth, target));
  }

  function onClick(event) {
    const button = event.target.closest?.('button.wf-tc-btn');
    if (!button || button.disabled) return;
    const carousel = button.closest('.wf-tc');
    const content = parts(carousel);
    if (!content) return;
    // One shared handler owns these arrows, including templates with legacy handlers.
    event.preventDefault();
    event.stopImmediatePropagation();
    const { view, cards } = content;
    const max = Math.max(0, view.scrollWidth - view.clientWidth);
    if (max < 1) return;
    const controls = Array.from(carousel.querySelectorAll('button.wf-tc-btn'));
    const direction = controls.indexOf(button) === 0 ? -1 : 1;
    const targets = [0, ...cards.map(card => cardPosition(view, card)), max].sort((a, b) => a - b);
    const current = view.scrollLeft;
    const target = direction > 0
      ? targets.find(position => position > current + 2) ?? 0
      : targets.slice().reverse().find(position => position < current - 2) ?? max;
    view.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  function onBlockSelect(event) {
    const card = event.target.closest?.('.wf-tc-card');
    const content = parts(card?.closest('.wf-tc'));
    if (content) content.view.scrollTo({ left: cardPosition(content.view, card), behavior: 'auto' });
  }

  // Delegation also covers sections replaced or added in the Shopify theme editor.
  document.addEventListener('click', onClick, options);
  document.addEventListener('shopify:block:select', onBlockSelect, options);
  window[key] = { version: '1.0.0', cleanup: () => controller.abort() };
})();
